export default __webpack_public_path__ + "static/media/main_all_background.b0ec3c70.jpg";